import {apiPost} from './api';

export default class ServicioCertificadoDAO {

    static enviar(datos) {
        return apiPost("/certificados/DAO/Enviar", datos);
    }

}